import React from 'react';
import { View } from 'react-native';

const ViewShot = React.forwardRef<unknown, { children: React.ReactNode }>(
  ({ children, ...props }, _ref) => <View {...props}>{children}</View>,
);

ViewShot.displayName = 'ViewShot';

export default ViewShot;
